import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Tag} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}


const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('along/class/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            const columns = [
                {
                    key: '$index', 
                    label: '序号'
                },
                {
                    key: 'orgName',
                    label: '部门名称'
                },
                {
                    key: 'employeeCode',
                    label: '职工号',
                    width: 100
                },
                {
                    key: 'employeeName',
                    label: '教师'
                },
                {
                    key: 'courseName',
                    label: '课程'
                },
                {
                    key: 'className',
                    label: '班级'
                },
                {
                    key: 'targetName',
                    label: '指标',
                    width: 150
                },
                {
                    key: 'status',
                    label: '状态',
                    render: (value) => {
                        if (value === 1) {
                            return <Tag color='#87d068'>开启</Tag>
                        } else if (value === 2) {
                            return <Tag color='#f50'>关闭</Tag>
                        }
                    }
                },
                {
                    key: 'evalCount',
                    label: '获得结果',
                    width: 80
                },
                {
                    key: 'avgScore',
                    label: '平均分',
                    width: 80
                },
                {
                    key: 'publisherCode',
                    label: '发起人工号',
                    width: 100
                },
                {
                    key: 'publisherName',
                    label: '发起人'
                },
                {
                    key: 'publishDate',
                    label: '发起时间',
                    width: 100
                },
                {
                    key: 'deadline',
                    label: '截止时间',
                    width: 100
                },
                {
                    key: 'termName',
                    label: '学期'
                }
            ]
            return {
                headers : utils.columns(columns),
                data: response.payload.data,
            }
        }
    }).then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data || []).length ? '' : '暂无数据...'
        }))
    )
}

const open = (ids) => {
    return fetch.post('along/class/open', ids)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const close = (ids) => {
    return fetch.post('along/class/close', ids)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const batchRemove = (ids) => {
    return fetch.post('along/class/delete', ids)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    setRefresh,
    onSelectData,
    onSelect,
    getSelection,
    querySearch,
    open,
    close,
    batchRemove
}